var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applicationPage"},[_c('HeadInfo',{attrs:{"hide-right-items":true}}),_c('div',{staticClass:"messageParty d-flex justify-content-center align-items-center"},[_c('div',{staticStyle:{"margin-bottom":"3rem"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.desc)}})])]),_c('FooterInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }